import type React from 'react';

import type { FieldValidator } from 'final-form';
import { Field } from 'react-final-form';

import { Label } from '#src/app/shared/components/adminShadcn';

import { ImageUploaderUppyWrapper } from './components/ImageUploaderUppyWrapper';

export const ImageField: React.FC<{
	validate?: FieldValidator<string | undefined>;
	fieldName: string;
	label: string;
}> = ({ validate, fieldName, label }) => {
	return (
		<div className="admin:mt-4">
			<Field<string | undefined> name={fieldName} validate={validate}>
				{({ meta, input: { onChange } }) => (
					<>
						<Label htmlFor={fieldName}>{label}</Label>
						<ImageUploaderUppyWrapper fieldName={fieldName} onChange={onChange} />
						{meta.touched && meta.error && (
							<p role="alert" className="admin:mt-1 admin:text-xs admin:text-destructive">
								{meta.error}
							</p>
						)}
					</>
				)}
			</Field>
		</div>
	);
};
